import { startOfDay, subMonths } from 'date-fns';

export const ANALYTICS_LIMITS = {
  maxDateRangeInDays: 7,
  sixMonthDate: subMonths(startOfDay(new Date()), 6),
};
